import request from "@/utils/followUp/request";

const BASE_URL = "/internal/hospWard";

// 医院管理-分页列表
export function hospitalPageList(query) {
  return request({
    url: `${BASE_URL}/list`,
    method: "get",
    params: query,
  });
}
// 医院管理-分页列表
export function getAllHospitalList(query) {
  return request({
    url: `${BASE_URL}/all`,
    method: "get",
    params: query,
  });
}

// 医院管理-新增医院
export function addHospital(data) {
  return request({
    url: `${BASE_URL}/save`,
    method: "post",
    data,
  });
}

// 医院管理-更新医院
export function updateHospital(data) {
  return request({
    url: `${BASE_URL}/save`,
    method: "patch",
    data,
  });
}

// 医院管理- 删除医院
export function deleteHospital(id) {
  return request({
    url: `${BASE_URL}/del/${id}`,
    method: "post",
  });
}

// 所有院区
export function getAllHospital(id) {
  return request({
    url: `${BASE_URL}/all`,
    method: "get",
  });
}
